import axios from 'axios';

const API_PREFIX = (import.meta.env.VITE_API_BASE_PATH || '/remediation/api').replace(/\/$/, '');

// Create axios instance with configured base URL
const apiClient = axios.create({
  baseURL: window.location.origin,
  withCredentials: true, // Include cookies for session management
  headers: {
    'Content-Type': 'application/json'
  }
});

// Preserve existing callsites while routing all API traffic through /remediation/api.
apiClient.interceptors.request.use((config) => {
  const originalUrl = String(config.url || '');

  // Session-cookie auth only: prevent bearer/token auth headers from being sent.
  if (config.headers) {
    delete config.headers.Authorization;
    delete config.headers.authorization;
  }

  if (originalUrl.startsWith('/api/')) {
    config.url = `${API_PREFIX}${originalUrl.slice(4)}`;
  } else if (originalUrl.startsWith('api/')) {
    config.url = `${API_PREFIX}/${originalUrl.slice(4)}`;
  }

  return config;
});

// Add response interceptor for global error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle common errors
    if (error.response?.status === 401) {
      console.warn('Unauthorized - session may have expired');
    } else if (error.response?.status === 403) {
      console.warn('Forbidden - insufficient permissions');
    } else if (error.response?.status === 500) {
      console.error('Server error:', error.response?.data?.message);
    }
    return Promise.reject(error);
  }
);

export default apiClient;
